export const Linkedin = ({ className }: { className?: string }) => {
  return (
    <div className={className}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 26 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.76758 5.43359C7.76758 6.07682 7.53483 6.63119 7.06934 7.09668C6.60384 7.56217 6.04948 7.79492 5.40625 7.79492C4.74609 7.79492 4.18327 7.56217 3.71777 7.09668C3.25228 6.63119 3.01953 6.07682 3.01953 5.43359C3.01953 4.77344 3.25228 4.21061 3.71777 3.74512C4.18327 3.27962 4.74609 3.04688 5.40625 3.04688C6.04948 3.04688 6.60384 3.27962 7.06934 3.74512C7.53483 4.21061 7.76758 4.77344 7.76758 5.43359ZM10.002 9.59766V22.75H14.0898V16.25C14.0898 15.3867 14.2337 14.6081 14.5215 13.9141C14.8092 13.2201 15.4779 12.873 16.5273 12.873C17.5768 12.873 18.1947 13.2624 18.3809 14.041C18.5671 14.8197 18.6602 15.5898 18.6602 16.3516V22.75H22.748V15.5391C22.748 13.7617 22.4476 12.2721 21.8467 11.0703C21.2458 9.86849 19.9128 9.26758 17.8477 9.26758C16.849 9.26758 16.0238 9.49186 15.3721 9.94043C14.7204 10.389 14.2591 10.8757 13.9883 11.4004H13.9121V9.59766H10.002ZM3.34961 9.59766H7.4375V22.75H3.34961V9.59766Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
};

